module.exports = __webpack_public_path__ + "img/screen.d08bacb1.png";